'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _mobx = require('mobx');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

/**
 * @private
 */
var Store = (_class = function () {

  /**
   * @private
   * @param {Object} props
   *   The properties
   * @param {number} props.slideIndex
   *   Initially active slideIndex
   */


  /**
   * A collection of hosts for fragments.
   * Each slide is a host.
   * @type {Array}
   */


  /**
   * Index of the currently active fragment
   * @type {number}
   */


  /**
   * Index of the currently active slide
   * Default to `0`. Is needed for the initial load to work correctly.
   * @see {@dekk/fragments/src/index.js~Fragment#render}
   * @type {number}
   */
  function Store() {
    _classCallCheck(this, Store);

    this.id = (0, _v2.default)();

    _initDefineProp(this, 'slideIndex', _descriptor, this);

    _initDefineProp(this, 'fragmentOrder', _descriptor2, this);

    _initDefineProp(this, 'fragmentIndex', _descriptor3, this);

    _initDefineProp(this, 'direction', _descriptor4, this);

    _initDefineProp(this, 'fragmentHosts', _descriptor5, this);

    _initDefineProp(this, 'notes', _descriptor6, this);

    // Bind methods
    this.toSlide = this.toSlide.bind(this);
    this.toNextSlide = this.toNextSlide.bind(this);
    this.toPrevSlide = this.toPrevSlide.bind(this);
    this.toFragment = this.toFragment.bind(this);
    this.toNextFragment = this.toNextFragment.bind(this);
    this.toPrevFragment = this.toPrevFragment.bind(this);
  }

  /**
   * Public methods.
   *
   * These methods can be used to modify the store.
   */


  /**
   * A collection of hosts for fragments.
   * Each slide is a host.
   * @type {Array}
   */


  /**
   * Direction of the slide movement (either -1, 0 or 1)
   * @type {number}
   */


  /**
   * Order of the currently active fragment
   * @type {number}
   */

  /**
   * Store Id
   * @type {String}
   */


  _createClass(Store, [{
    key: 'toSlide',


    /**
     * @private
     */
    value: function toSlide(slideIndex) {
      this.direction = slideIndex > this.slideIndex ? 1 : -1;
      this.slideIndex = slideIndex;
    }

    /**
     * @private
     */

  }, {
    key: 'toNextSlide',
    value: function toNextSlide() {
      this.toSlide(this.slideIndex + 1);
      this.toFragment(0);
    }

    /**
     * @private
     */

  }, {
    key: 'toPrevSlide',
    value: function toPrevSlide() {
      var _fragmentHosts$length = this.fragmentHosts[this.slideIndex - 1].length,
          prevFragmentCount = _fragmentHosts$length === undefined ? 0 : _fragmentHosts$length;

      var prevLastFragment = Math.max(0, prevFragmentCount - 1);
      this.toSlide(this.slideIndex - 1);
      this.toFragment(prevLastFragment);
    }

    /**
     * @private
     */

  }, {
    key: 'toFragment',
    value: function toFragment(fragmentIndex) {
      if (this.fragmentHosts[this.slideIndex].length - 1 >= fragmentIndex) {
        this.fragmentOrder = this.fragmentHosts[this.slideIndex][fragmentIndex];
      } else {
        this.fragmentOrder = undefined;
      }
      this.fragmentIndex = fragmentIndex;
    }

    /**
     * @private
     */

  }, {
    key: 'toNextFragment',
    value: function toNextFragment() {
      this.toFragment(this.fragmentIndex + 1);
    }

    /**
     * @private
     */

  }, {
    key: 'toPrevFragment',
    value: function toPrevFragment() {
      this.toFragment(this.fragmentIndex - 1);
    }
  }, {
    key: 'publicMethods',
    get: function get() {
      return {
        toSlide: this.toSlide,
        toNextSlide: this.toNextSlide,
        toPrevSlide: this.toPrevSlide,
        toFragment: this.toFragment,
        toNextFragment: this.toNextFragment,
        toPrevFragment: this.toPrevFragment
      };
    }
  }]);

  return Store;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'slideIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'fragmentOrder', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'fragmentIndex', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'direction', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'fragmentHosts', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'notes', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [].concat(_toConsumableArray(new Array(512))).map(function () {
      return null;
    });
  }
})), _class);
exports.default = Store;
//# sourceMappingURL=index.js.map